import React from 'react';
import DrawerTemplate from '../../components/common/drawer/DrawerTemplate';
import ScrollTop from '../../components/common/footer/ScrollTop';
import ForcedPasswordChangeContainer from '../../containers/common/ForcedPasswordChangeContainer';

const MainPage = (props) => {
  return (
   <>
    <div id="back-to-top-anchor"></div>
    {/* 로그인 상태에서 비밀번호 변경이 강제될 때(pwdCngReqYn='Y') 모든 보호된 화면 위에
        덮어씌운다 - bito 권한 체계 검토(2026-10-23) R1. */}
    <ForcedPasswordChangeContainer />
    <DrawerTemplate/>

    <ScrollTop  {...props} />

   </>
  )
};

export default MainPage;
